import { Component, OnInit } from '@angular/core';

import { CatalogoServiciosService } from '../../services/catalogo-servicios.service';
import { MonedaService } from '../../services/moneda.service';
import { ConsorciosService } from '../../services/consorcios.service';

import { Moneda } from '../../model/moneda';
import { Consorcio } from '../../model/consorcio';
import { CatalogoServicios } from '../../model/catalogo-servicios';

@Component({
  selector: 'app-catalogo-servicios-list',
  templateUrl: './catalogo-servicios-list.component.html',
  styleUrls: ['./catalogo-servicios-list.component.css']
})
export class CatalogoServiciosListComponent implements OnInit {

  public servicioSeleccionado: CatalogoServicios;
  public modoEdicion: boolean = false;


  public servicios: CatalogoServicios[];
  public consorcio: Consorcio;
  public consorcios: Consorcio[];
  public query: any;
  public filtro:string;

  constructor(
    private _servicios: CatalogoServiciosService,
    private _consorcioService: ConsorciosService
  ) { }

  ngOnInit() {
     this.filtro = "";
    this.servicios = [];
    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.cargarConsorcios();
  }

  cargarConsorcios() {
    this.query = { "email": sessionStorage.getItem("login") };

    this._consorcioService.getConsorciosUsuario(this.query)
      .subscribe(
      data => { this.consorcios = data; },
      err => {
        console.log(err);
      });

  }

  cargarServicios() {
    this._servicios.getServicios(this.consorcio)
      .subscribe(
      data => this.servicios = data,
      err => {
        console.clear();
        console.log(err._body);
      });

  }


  editarRegistro(_servicio: CatalogoServicios) {
    console.log(_servicio);
    this.servicioSeleccionado = _servicio;
    this.modoEdicion = true;
  }


  agregarRegistro() {
    if(this.consorcio.codigoConsorcio === null){
      return;
    }
    this.servicioSeleccionado = new CatalogoServicios();
    this.modoEdicion = true;
  }


  regresar() {
    this.modoEdicion = false;
    this.cargarServicios();
  }


}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/catalogo-servicios-list/catalogo-servicios-list.component.ts